import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api"
import {
    PlacementProcessDocumentExistenceFilterDto,
    PlacementProcessListItemDto,
    PlacementProcessOriginDto,
    PlacementProcessStatusDto
} from "../../api/sls";
import {pageLoadingStore} from "../PageLoadingStore";

class SlsOverviewStore {
    get toAbsolute(): string | undefined {
        return this._toAbsolute
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value
    }
    get fromAbsolute(): string | undefined {
        return this._fromAbsolute
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }
    get toRelative(): string | undefined {
        return this._toRelative
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value
    }
    get fromRelative(): string | undefined {
        return this._fromRelative
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }
    get query(): string | undefined {
        return this._query
    }

    set query(value: string | undefined) {
        this._query = value
    }
    get page(): number {
        return this._page
    }

    set page(value: number) {
        this._page = value
    }

    get size(): number {
        return this._size
    }

    set size(value: number) {
        this._size = value
    }

    get pages(): number {
        return this._pages
    }

    set pages(value: number) {
        this._pages = value
    }

    get items(): PlacementProcessListItemDto[] {
        return this._items
    }

    set items(value: PlacementProcessListItemDto[]) {
        this._items = value
    }

    get customerId(): string | undefined {
        return this._customerId
    }

    set customerId(value: string | undefined) {
        this._customerId = value
    }

    get usernames(): string[] {
        return this._usernames
    }

    set usernames(value: string[]) {
        this._usernames = value
    }

    get origins(): PlacementProcessOriginDto[] | undefined {
        return this._origins
    }

    set origins(value: (PlacementProcessOriginDto[] | string[] | undefined)){
        // accept string[] from router, cast to enum values
        if (!value) {
            this._origins = undefined
            return
        }
        // If already correct type, assign
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this._origins = value as PlacementProcessOriginDto[]
    }

    get status(): PlacementProcessStatusDto[] | undefined {
        return this._status
    }

    set status(value: (PlacementProcessStatusDto[] | string[] | undefined)) {
        // accept string[] from router, cast to enum values
        if (!value) {
            this._status = undefined
            return
        }
        // If already correct type, assign
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this._status = value as PlacementProcessStatusDto[]
    }

    get documentExistence(): PlacementProcessDocumentExistenceFilterDto[] | undefined {
        return this._documentExistence
    }

    set documentExistence(value: (PlacementProcessDocumentExistenceFilterDto[] | string[] | undefined)) {
        // accept string[] from router, cast to enum values
        if (!value) {
            this._documentExistence = undefined
            return
        }
        // If already correct type, assign
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this._documentExistence = value as PlacementProcessDocumentExistenceFilterDto[]
    }

    private _items: PlacementProcessListItemDto[] = []
    private _pages: number = 0
    private _page: number = 1
    private _size: number = 25
    private _query: string | undefined
    private _fromRelative?: string
    private _toRelative?: string
    private _fromAbsolute?: string
    private _toAbsolute?: string
    private _customerId: string | undefined
    private _usernames: string[] = []
    private _status: PlacementProcessStatusDto[] | undefined
    private _origins: PlacementProcessOriginDto[] | undefined
    private _documentExistence: PlacementProcessDocumentExistenceFilterDto[] | undefined

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        pageLoadingStore.loading = true
        const result = await catchApi(async () => await api.sls.api.listPlacementProcesses({
            page: this.page - 1,
            size: this.size,
            q: this.query,
            fromRelative: this.fromRelative,
            toRelative: this.toRelative,
            fromAbsolute: this.fromAbsolute,
            toAbsolute: this.toAbsolute,
            // Backend expects an array; frontend uses single id
            customerIds: this.customerId ? [this.customerId] : undefined,
            usernames: this.usernames.length ? this.usernames : undefined,
            status: this.status && this.status.length ? this.status : undefined,
            origins: this.origins && this.origins.length ? this.origins : undefined,
            documentExistence: this.documentExistence && this.documentExistence.length ? this.documentExistence : undefined,
        }))
        const data = result?.data
        if (data?.items) {
            this.items = data.items
            this.pages = data.totalPages || 0
        } else {
            this.items = []
            this.pages = 0
        }
        pageLoadingStore.loading = false
    }
}

const slsOverviewStore = new SlsOverviewStore()

export {
    slsOverviewStore
}
